/** Компактные SVG для страницы «Техническая информация» (currentColor). */

type IconProps = { size?: number; className?: string };

const base = { display: 'block' as const };

export function IconTarget({ size = 22 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" style={base} aria-hidden>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" strokeLinecap="round" />
    </svg>
  );
}

export function IconLayers({ size = 22 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" style={base} aria-hidden>
      <path d="M12 4 4 8l8 4 8-4-8-4Z" strokeLinejoin="round" />
      <path d="m4 12 8 4 8-4" strokeLinejoin="round" />
      <path d="m4 16 8 4 8-4" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCode({ size = 22 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" style={base} aria-hidden>
      <path d="m8 7-5 5 5 5M16 7l5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconShield({ size = 22 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" style={base} aria-hidden>
      <path d="M12 3 5 6v5c0 5 4 8 7 9 3-1 7-4 7-9V6l-7-3Z" strokeLinejoin="round" />
    </svg>
  );
}

export function IconReact({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={base} aria-hidden>
      <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="1.35" />
      <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="1.35" transform="rotate(60 12 12)" />
      <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="1.35" transform="rotate(-60 12 12)" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  );
}

export function IconVite({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={base} aria-hidden>
      <path d="M13 3 21 19 12 14 3 19 13 3Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M12 14 8 10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

export function IconTypeScript({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={base} aria-hidden>
      <rect x="3" y="3" width="18" height="18" rx="4" opacity={0.18} />
      <text
        x="12"
        y="15.5"
        textAnchor="middle"
        fontSize="10"
        fontWeight="800"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fill="currentColor"
      >
        TS
      </text>
    </svg>
  );
}

export function IconNest({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={base} aria-hidden>
      <path d="M12 4c-4 0-7 3-7 7s3 7 7 7 7-3 7-7-3-7-7-7Z" strokeLinejoin="round" />
      <path d="M12 8v8M9 10.5c1.5 1 4.5 1 6 0" strokeLinecap="round" />
    </svg>
  );
}

export function IconDatabase({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={base} aria-hidden>
      <ellipse cx="12" cy="6" rx="7" ry="3" />
      <path d="M5 6v6c0 1.7 3 3 7 3s7-1.3 7-3V6" />
      <path d="M5 12v6c0 1.7 3 3 7 3s7-1.3 7-3v-6" />
    </svg>
  );
}

export function IconRedis({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={base} aria-hidden>
      <path d="M5 8c0-1 3.5-2 7-2s7 1 7 2-3.5 2-7 2-7-1-7-2Z" />
      <path d="M5 12c0 1 3.5 2 7 2s7-1 7-2" />
      <path d="M5 16c0 1 3.5 2 7 2s7-1 7-2" />
    </svg>
  );
}

export function IconLock({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" style={base} aria-hidden>
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" strokeLinecap="round" />
    </svg>
  );
}

export function IconCookie({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={base} aria-hidden>
      <circle cx="12" cy="12" r="8" />
      <circle cx="9" cy="9" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="14" cy="10" r="1" fill="currentColor" stroke="none" />
      <circle cx="11" cy="14" r="1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="15" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconDocker({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={base} aria-hidden>
      <path d="M4 15h2v-2H4v2Zm3 0h2v-2H7v2Zm0-3h2v-2H7v2Zm3 3h2v-2h-2v2Zm0-3h2v-2h-2v2Zm0-3h2V9h-2v2Zm3 6h2v-2h-2v2Z" strokeLinejoin="round" />
      <path d="M17 12h2c0 3-2 4.5-4 5" strokeLinecap="round" />
    </svg>
  );
}

export function IconBrowser({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" style={base} aria-hidden>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 8h18" />
      <circle cx="6" cy="6" r="0.9" fill="currentColor" />
      <circle cx="8.5" cy="6" r="0.9" fill="currentColor" opacity={0.5} />
    </svg>
  );
}

export function IconServer({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" style={base} aria-hidden>
      <rect x="4" y="4" width="16" height="6" rx="1.5" />
      <rect x="4" y="14" width="16" height="6" rx="1.5" />
      <circle cx="8" cy="7" r="1" fill="currentColor" />
      <circle cx="8" cy="17" r="1" fill="currentColor" />
    </svg>
  );
}

export function IconMicrophone({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" style={base} aria-hidden>
      <rect x="9" y="2" width="6" height="11" rx="3" />
      <path d="M5 10v1a7 7 0 0 0 14 0v-1M12 18v4M8 22h8" strokeLinecap="round" />
    </svg>
  );
}

export function IconStorage({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" style={base} aria-hidden>
      <path d="M4 8h16M4 16h16" />
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <circle cx="7" cy="8" r="1" fill="currentColor" />
      <circle cx="7" cy="16" r="1" fill="currentColor" />
    </svg>
  );
}

export function IconQueue({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" style={base} aria-hidden>
      <rect x="3" y="5" width="18" height="3" rx="1" />
      <rect x="3" y="11" width="18" height="3" rx="1" />
      <rect x="3" y="17" width="18" height="3" rx="1" />
    </svg>
  );
}
